/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// 商品名にHTML要素をここで付与させてデザイン調整
// 商品ページ
const productTitle = document.querySelectorAll('.product__title');
// コレクションページ
const cardName = document.querySelectorAll('.card__name.h4');

if (productTitle) {
  productTitle.forEach((v, i) => {
    const titleInner = v.innerHTML;
    let admin;
    
    if (titleInner.includes('__')) {
      admin = titleInner.replace('__', ' <span>') + '</span>';
      productTitle[i].innerHTML = admin;
    }
  });
}

if (cardName) {
  cardName.forEach ((v, i) => {
    const nameInner = v.innerHTML;
    let admin;

    if (nameInner.includes('・')) {
      admin = nameInner.replace('・', '<span class="en-del">・').replace('__', '</span><span>') + '</span>';
    } else if (nameInner.includes(' 7')) {
      admin = nameInner.replace(' 7', '<span class="card-br">7').replace('__', '</span><span>') + '</span>';
    } else if (nameInner.includes('__')) {
      admin = nameInner.replace('__', ' <span>') + '</span>';
    } else {
      admin = nameInner;
    } 
    cardName[i].innerHTML = admin;
  });
}